import React, { useEffect, useState } from 'react';
import { IItemTab } from '@/schemas/common';
import { useHistory } from 'react-router-dom';
import ksBridge from '@ks/ks-bridge';
import { toLogin } from '@/utils/helpers';
import IconFont from '@/components/Iconfont';
import './index.scss';
import { Dispatch, RootState } from '@/store';
import { connect } from 'react-redux';
import { USER_REFRESH_TIME } from '@/configs/constants';

const needLoginLinks = ['/order/records'];

const mapState = (state: RootState) => ({
  isLogin: state.user.isLogin,
  // isDoctor: state.user.doctor,
  totalUnread: state.im.totalUnread,
  pollingFrequency: state.im.pollingFrequency,
  jobType: state.user.jobType,
  newMessage: state.workstation.newMessage
});

const mapDispatch = (dispatch: Dispatch) => ({
  getAllUnread: dispatch.im.getAllUnread,
  getMessageList: dispatch.workstation.getMessageList
});

interface INavBottomProps
  extends ReturnType<typeof mapState>,
    ReturnType<typeof mapDispatch> {
  data: IItemTab[];
  hasLogin: boolean;
  iconfont?: boolean;
}
let messageTimer;
// 数据刷新时间
const GAP = 20;
const NavBottom = (props: INavBottomProps) => {
  const {
    isLogin,
    totalUnread,
    pollingFrequency,
    jobType,
    getMessageList,
    newMessage
  } = props;
  const { data, hasLogin, iconfont } = props;
  const [startQuery, setStartQuery] = useState(false); // 是否已经开始轮训
  const history = useHistory();
  let timer: NodeJS.Timer | null;

  useEffect(() => {
    // TODO 判断方式不太优雅,待优化
    if (props.isLogin && !startQuery) {
      // 当前页面如果在首页,登录后才查未读消息,不登录不查
      // getUnreadMsg();
      getMessage();
      messageTimer = setInterval(() => {
        getMessage();
      }, 1000 * GAP);
      setStartQuery(true);
    }
    return () => {
      // console.log('---clear timer');
      clearTimeout(timer as NodeJS.Timer);
      clearInterval(messageTimer);
      timer = null;
    };
  }, [isLogin]);

  const getMessage = async () => {
    await getMessageList({ jobType, hideLoading: true });
  };
  const getUnreadMsg = async () => {
    // const doctorFlag = isDoctor ? UNREAD_TYPE.Doctor : UNREAD_TYPE.User;
    await props.getAllUnread();
    const timerFrequency = pollingFrequency || USER_REFRESH_TIME;
    clearTimeout(timer as NodeJS.Timer);
    timer = setTimeout(() => {
      getUnreadMsg();
    }, timerFrequency);
  };

  const handleChangeNav = (link) => {
    if (!link) {
      return;
    }
    if (!hasLogin && needLoginLinks.includes(link)) {
      toLogin(
        () => {
          history.push(link);
        },
        () => {
          // do nothing
        }
      );
    } else {
      history.replace(link);
    }
  };
  const isShow = ksBridge.sniff.isInApp;

  return (
    <>
      {isShow && (
        <div className="nav-bottom-wrapper">
          {data.map((item: IItemTab) => (
            <span
              key={`${item.title}-${item.iconClassName}`}
              onClick={() => {
                handleChangeNav(item.link);
              }}
              className={`${item.link ? 'normal' : 'active'} ${
                item.title === '消息' && newMessage ? 'message-tips' : ''
              }`}
              role="presentation"
            >
              {iconfont ? (
                <IconFont icon={item.iconClassName} />
              ) : (
                <i className={`icon-img ${item.iconClassName}`} />
              )}

              <span>{item.title}</span>
              {totalUnread > 0 && item.title === '咨询记录' ? (
                <i className="red-dot" />
              ) : null}
            </span>
          ))}
        </div>
      )}
    </>
  );
};

export default connect(mapState, mapDispatch)(NavBottom);
